import { ProgramViewHeader } from "src/components";

export const ProgramView: React.FC = () => {
  return (
    <div className="program-page program-view app-theme2 pb-3">
      <ProgramViewHeader />
    </div>
  );
};
